import React, { useContext } from "react";
import { cloudCardItems } from "../../../../global/utils/constants/cloudData";
import CatalogueBackground from "../../../../assets/images/download-cutsheet2.png";
import useSWR from "swr";
import DownloadSection from "../../../../lib/downloadSection";
import { fetcher } from "../../../../lib/apiConstants";
import { LoginContext } from "../../../../lib/loginContext";

const PAGE_X = "px-6 lg:px-[120px]";

const FeatureSection = ({
  image,
  title,
  paragraphs,
  imageLeft = true,
  sectionBg = "#f8f8f8",
  textAlign = "left",
  imageMaxWidth = "590px",
}) => (
  <div className="bg-white w-full flex flex-col lg:flex-row lg:h-[540px]">
    <div
      className={`w-full lg:w-1/2 flex items-center justify-center py-5 lg:py-0 min-h-[320px] lg:min-h-0 order-1 ${imageLeft ? "lg:order-1" : "lg:order-2"
        }`}
      style={{ backgroundColor: sectionBg }}
    >
      <img
        src={image}
        alt={title}

      />
    </div>
    <div
      className={`w-full lg:w-1/2 flex items-center justify-center min-h-[320px] lg:min-h-0 px-6 lg:px-[65px] order-2 ${imageLeft ? "lg:order-2" : "lg:order-1"
        }`}
      style={{ backgroundColor: sectionBg }}
    >
      <div
        className={`w-full max-w-[590px] flex flex-col gap-5 ${textAlign === "right" ? "text-right items-end" : "text-left items-start"
          }`}
      >
        <h3 className="text-[#171717] text-2xl font-medium font-['Inter'] leading-normal w-full">
          {title}
        </h3>
        <div className="text-base font-normal font-['Poppins'] leading-[26px] text-[#3b3b3b] w-full whitespace-pre-wrap">
          {paragraphs.map((paragraph, index) => (
            <p key={index} className={index < paragraphs.length - 1 ? "mb-0" : ""}>
              {paragraph}
            </p>
          ))}
        </div>
      </div>
    </div>
  </div>
);

const CloudContent = () => {
  const { data: products, isLoading: productsLoading } = useSWR(
    "products/",
    fetcher,
  );
  const { isLoggedIn } = useContext(LoginContext);

  return (
    <div className="bg-white w-full font-inter">
      {/* Hero */}
      <section
        className={`flex flex-col items-center justify-center gap-6 ${PAGE_X} pt-28 sm:pt-24 min-h-[258px] text-center`}
      >
        <h1 className="text-black text-[32px] font-medium font-['Inter'] leading-normal max-w-[1004px]">
          Remote & Hybrid System
        </h1>
        <p className="text-[#5b5b5b] text-[20px] font-medium font-['Poppins'] leading-normal max-w-[872px]">
          Securely connect, configure, and manage distributed access control
          systems through scalable cloud-enabled remote management with full
          customer data ownership.
        </p>
      </section>


      {/* Feature sections */}
      <div className="w-full bg-white mt-6">
        {cloudCardItems.map((item) => (
          <FeatureSection
            key={item.id}
            image={item.image}
            title={item.title}
            paragraphs={item.paragraphs}
            imageLeft={item.imageLeft}
            sectionBg={item.sectionBg}
            textAlign={item.textAlign}
            imageMaxWidth={item.imageMaxWidth}
          />
        ))}
      </div>

      {/* Bottom info */}
      <section className="w-full  flex items-center justify-center min-h-[303px] px-6 lg:px-[120px] py-10">
        <p className="text-[#5b5b5b] text-base font-normal font-['Poppins'] leading-[26px] text-center max-w-[1244px]">
          All of the RMC software has been thoroughly tested in real-world
          environments, and will continue to be built out to support our dealers'
          go-to-market strategy. We believe that the RMC software solution is a
          superior alternative to NAT, port forwarding and Virtual Private
          Networking (VPN) technology, enabling easy and secure remote access to
          field-deployed systems. IT managers should also agree, as they can
          implement remote access and connectivity securely without mangling the
          existing network infrastructure and policies.
        </p>
      </section>
      {isLoggedIn && (
        <div className={`  mx-auto `}>
          <DownloadSection
            title="Cut Sheet"
            description="Learn about 2.0 RMC features"
            backgroundImage={CatalogueBackground}
            buttonText="Download Now"
            linkField="others_link"
            products={products || []}
            isLoading={productsLoading}
            filterBySlug="bp-4d"
            showOnlyFirst={true}
          />
        </div>
      )}

    </div>

  );
};

export default CloudContent;
